import React from 'react'
import { connect } from 'react-redux'
import { RouteProps } from 'react-router-dom'

import PageFrame from 'admin/components/common/PageFrame'
import Text from 'admin/components/common/Text'
import {
  WithContextProps,
  withContext,
} from 'admin/components/common/withContext'
import config from 'admin/config/main'
import { State } from 'admin/redux/ducks'
import { logoutUserAction, LoginState } from 'admin/redux/ducks/login'
import { AlertType } from 'types'

class Logout extends React.Component<
  LogoutProps & RouteProps & WithContextProps,
  any
> {
  constructor(props) {
    super(props)
  }

  componentDidMount() {
    const { logoutUser } = this.props
    const redirectUri = `${window.location.origin  }/${  config.basePath}`
    logoutUser(redirectUri).catch(() => {
      // Do redirected logout
      window.location.href = redirectUri
    })
  }

  render() {
    return (
      <PageFrame>
        <div className="Box">
          <h1>
            <Text>general.logging_out</Text>
          </h1>
        </div>
      </PageFrame>
    )
  }
}

type LogoutProps = {
  login: LoginState
  logoutUser: (redirectUri?: string, alert?: AlertType) => Promise<string>
}

const mapStateToProps = (state: State, ownProps) => {
  return {
    login: state.login as LoginState,
  }
}

const mapDispatchToProps = dispatch => {
  return {
    logoutUser: (redirectUri?: string, alert?: AlertType) =>
      dispatch(logoutUserAction(redirectUri)),
  }
}

export default connect<any, any, any>(
  mapStateToProps,
  mapDispatchToProps,
)((withContext(Logout)))
